import React, {Component} from "react";
import {Input} from "reactstrap";
import debounce from "lodash-es/debounce";
import {ApiPost} from "../../../shared/services/api-service";
import PhaseReportTableRow from "../training-phases/PhaseReportTableRow";
import {connect} from "react-redux";
import oitsActions from "../../store/oits/action-creators";
import trainingPhasesActionCreators from "../../store/training-phases/action-creators";
import reportModel from "../../models/report";
import './CommonSearchReports.scss'

class CommonSearchReports extends Component {

  constructor(props) {
    super(props);
    this.state = {
      search: '',
      searchResults: []
    }
  }

  debounceInput = debounce(this.onSearch, 300);
  onSearch(value) {
    if(!value) {
      this.setState({
        search: value
      })
      return;
    }
    ApiPost('/api/v1/reports/search', {
      oit_guid: this.props.oitGuid,
      text: value
    })
      .then(res => {
        this.props.pushReports(res)
        this.setState({
          searchResults: res.map(reportModel)
        })
      })
  }

  onInput(e) {
    let value = e.target.value
    this.setState({search: value})
    this.debounceInput(value)
  }

  onBlur() {
    setTimeout(() => {
      this.setState({
        search: "",
        searchResults: []
      })
    }, 300)
  }
  render() {
    return (
      <div className="common-search-reports" style={{maxWidth: '300px'}}>
        <Input placeholder="Search.." value={this.state.search} onChange={(e) => this.onInput(e)} onBlur={() => this.onBlur()}/>
        {!!this.state.search && <div className="search-results">
          <table>
            <tbody>
            {this.state.searchResults.map((report) => {
              return (
                <PhaseReportTableRow
                  key={report.guid}
                  onAddScheduledReport={(reportGuid, type) => {
                    return this.addScheduledReport(reportGuid, type);
                  }}
                  onDeleteDraftReport={(reportGuid) => {
                    return this.props.deleteDraftReport(reportGuid);
                  }}
                  onDeleteScheduledReport={(reportGuid) => {
                    return this.props.deleteScheduledReport(reportGuid);
                  }}
                  onSendReminder={reportGuid => this.onSendReminder(reportGuid)}
                  onViewReport={reportGuid => this.props.viewReport(reportGuid)}
                  onEditReport={reportGuid => this.props.editReport(reportGuid)}
                  report={report}
                />
              );
            })}
            </tbody>
          </table>
          {!!this.state.searchResults && this.state.searchResults.length === 0 && (
            <h6>No reports found for <i>"{this.state.search}"</i></h6>
          )}
        </div>}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    viewReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.viewReport(reportGuid));
    },
    pushReports: (reports) => {
      return dispatch(trainingPhasesActionCreators.replaceReports(reports))
    },
    editReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.editReport(reportGuid));
    },
    deleteDraftReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.deleteDraftReport(reportGuid));
    },
    deleteScheduledReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.deleteScheduledReport(reportGuid));
    },

  }
}

export default connect(null, mapDispatchToProps)(CommonSearchReports);
